function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as storeApi from '@/api/store.js';
import * as categoryApi from '@/api/categoryApi.js';
export default {
  components: {},
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      title: '小程序名称占位',
      props: {
        children: 'categoryList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        leaf: 3
      },
      // 分类
      merCateList: [],
      // 分类
      initId: null,
      editDialogConfig: {
        visible: false,
        url: null
      },
      hasConfirm: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.hasConfirm = null;
    var _this$$route$query = this.$route.query,
      id = _this$$route$query.id,
      name = _this$$route$query.name;
    this.initId = id;
    this.title = "".concat(name, "-\u5546\u54C1\u6388\u6743");
    this.handlerGetListData();
    this.initSearch();
  },
  methods: {
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      storeApi.getThirdSkuList(_objectSpread(_objectSpread({}, this.listPram), {}, {
        customerId: this.initId
      })).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    // 修改状态
    onchangeIsShow: function onchangeIsShow(row) {
      var _this2 = this;
      var _ref = row || {},
        id = _ref.id,
        status = _ref.status;
      storeApi.changeThirdState({
        ids: [id],
        status: status
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.$message.success('修改成功');
              _this2.handlerGetListData();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))).catch(function () {
        _this2.handlerGetListData();
      });
    },
    changePrice: function changePrice(row) {
      var _this3 = this;
      var _ref3 = row || {},
        supplyPrice = _ref3.supplyPrice,
        sellPrice = _ref3.sellPrice,
        id = _ref3.id;
      storeApi.changeThirdPrice({
        supplyPrice: supplyPrice,
        sellPrice: sellPrice,
        id: id
      }).then(function (res) {
        _this3.$message.success('操作成功！');
        _this3.handlerGetListData();
        _this3.hasConfirm = null;
      }).catch(function (err) {
        var _ref4 = err && err.data || {},
          code = _ref4.code,
          msg = _ref4.msg;
        _this3.submitLoading = false;
        if (code == 601 && !_this3.hasConfirm) {
          storeApi.checkComfirm(msg).then(function (res) {
            _this3.hasConfirm = res && res.hasConfirm;
            _this3.changePrice();
          });
        } else {
          _this3.handlerGetListData();
        }
      });
    },
    initSearch: function initSearch() {
      this.getCategorySelect();
    },
    getCategorySelect: function getCategorySelect() {
      var _this4 = this;
      this.merCateList = [];
      categoryApi.jdCateLists().then(function (res) {
        _this4.merCateList = res;
      });
    },
    importGoodsChange: function importGoodsChange() {
      this.editDialogConfig = {
        visible: true,
        url: null
      };
    },
    submitImport: function submitImport() {
      var _this$editDialogConfi,
        _this5 = this;
      if (!((_this$editDialogConfi = this.editDialogConfig) !== null && _this$editDialogConfi !== void 0 && _this$editDialogConfi.url)) {
        this.$message.warning('请上传文件！');
        return;
      }
      ;
      storeApi.importThirdGoods({
        url: this.editDialogConfig.url,
        customerId: this.initId
      }, this.hasConfirm ? {
        hasConfirm: this.hasConfirm
      } : {}).then(function (res) {
        _this5.$message.success('操作成功！');
        _this5.handlerGetListData();
        _this5.editDialogConfig.visible = false;
        _this5.hasConfirm = null;
      }).catch(function (err) {
        var _ref5 = err && err.data || {},
          code = _ref5.code,
          msg = _ref5.msg;
        _this5.submitLoading = false;
        if (code == 601 && !_this5.hasConfirm) {
          storeApi.checkComfirm(msg).then(function (res) {
            _this5.hasConfirm = res && res.hasConfirm;
            _this5.submitImport();
          });
        }
      });
    },
    exportSku: function exportSku() {
      storeApi.exportThird(_objectSpread(_objectSpread({}, this.listPram), {}, {
        customerId: this.initId
      })).then(function (res) {
        window.open(res.fileName);
      });
    }
  }
};